// extracted by mini-css-extract-plugin
export default {"root":"AlphabetSelect-root_B1av4"};